import cn from 'classnames'

import { WarningIcon } from '@components/icons/WarningIcon'
import { NumberFieldProps } from './interface'

export function NumberField({
  label,
  placeholder,
  className,
  inputClassName,
  disabled,
  pattern,
  error,
  touched,
  labelClassName,
  rightIcon,
  leftIcon,
  showErrorMsg = true,
  showLength,
  value,
  maxLength,
  readOnly,
  ...props
}: NumberFieldProps) {
  return (
    <div className={cn('w-full', className)} id={props.name}>
      {label && (
        <div
          className={cn(
            'text-[12px] text-secondary-1 dark:text-dark-10 mb-[4px] font-light',
            labelClassName
          )}
        >
          {label}
        </div>
      )}
      <div className='relative flex items-center w-full'>
        {leftIcon && (
          <div className='absolute left-0 ml-[20px]'>{leftIcon}</div>
        )}
        <input
          className={cn(
            'flex w-full h-[40px] leading-10 border-[1px] focus:outline-none text-[14px] text-secondary dark:text-dark-10 dark:bg-dark-8 font-light rounded-[8px] p-[10px] disabled:bg-gray-4 disabled:text-gray-10 focus:border-primary focus:text-primary placeholder:text-secondary-1',
            {
              'border-gray-3 dark:border-purple': !(touched && error),
              'border-red-3': touched && error,
              'pr-[30px]': rightIcon,
              'pl-[50px]': leftIcon,
            },
            inputClassName
          )}
          data-test={props.name}
          value={value}
          maxLength={maxLength}
          autoComplete='off'
          placeholder={placeholder ?? label}
          disabled={disabled}
          pattern={pattern}
          readOnly={readOnly}
          {...props}
        />

        {rightIcon && (
          <div className='absolute right-0 mr-[20px]'>{rightIcon}</div>
        )}
      </div>
      {showErrorMsg && touched && error && (
        <div className='flex items-center mt-[10px]'>
          <div className='text-[12px] text-red-3'>{error}</div>
        </div>
      )}
      {showLength ? (
        <div className='flex mt-[5px] space-x-[4px] items-center justify-end mobile:justify-start'>
          <span>
            <WarningIcon className='text-primary' width='16' height='16' />
          </span>
          <span className='font-light text-[12px] text-secondary-1'>
            {`ไม่เกิน ${maxLength?.toLocaleString()} ตัวอักษร ( ${
              value?.toString().length.toLocaleString() || 0
            }/
          ${maxLength?.toLocaleString()})`}
          </span>
        </div>
      ) : null}
    </div>
  )
}
